/* eslint-disable */
function extend(..._arg: any[]/*obj1, obj2, [objn] */) {
  const args = [].slice.call(arguments);
  let deep = false;
  const result = args[0];
  if (isUnextendable(result)) {
    throw new Error('extendee must be an object');
  }
  const extenders = args.slice(1);
  const len = extenders.length;
  for (let i = 0; i < len; i++) {
    const extender = extenders[i];
    for (const key in extender) {
      if (Object.prototype.hasOwnProperty.call(extender, key)) {
        const value = extender[key];
        if (deep && isCloneable(value)) {
          const base = Array.isArray(value) ? [] : {};
          result[key] = extend(
            true,
            Object.prototype.hasOwnProperty.call(result, key) &&
              !isUnextendable(result[key])
              ? result[key]
              : base,
            value,
          );
        } else {
          result[key] = value;
        }
      }
    }
  }
  return result;
}

function isCloneable(obj: any) {
  return {}.toString.call(obj) == '[object Object]';
}

function isUnextendable(val: any) {
  return !val || (typeof val != 'object' && typeof val != 'function');
}


export default extend